import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import type { CreditSummaryResponse, GenericResponse, StatementResponse } from '@/features/credits/types/credits.types';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';

class CreditService {
  async getSummary(customer_uuid: string, month_year: string): Promise<CreditSummaryResponse> {
    const newHeaders = buildCommonHeaders({
      withLocation: true
    });

    const response = await apiClient.post<GenericResponse>(
      API_ENDPOINTS.credit.get(customer_uuid),
      {},
      {
        headers: newHeaders,
        params: { month_year }
      }
    );
    return response.data;
  }

  async getStatements(customer_uuid: string): Promise<StatementResponse> {
    const newHeaders = buildCommonHeaders({
      withLocation: true
    });

    const response = await apiClient.post<GenericResponse>(
      API_ENDPOINTS.credit.statementList,
      {},
      {
        headers: newHeaders,
        params: { customer_uuid }
      }
    );
    return response.data as StatementResponse;
  }
}

export const creditService = new CreditService();
